import { Fragment } from 'react';
import {
    CREATE_PERMISSION,
    READ_PERMISSION,
    UPDATE_PERMISSION,
    SERVICE_CLIENT_AUTH,
} from 'src/constants/permissions';
import { PermissionsGuard } from './components';
import { ServiceClientsList } from 'src/views/serviceClient/ServiceClientsListView';
import { ServiceClientsDetailsView } from 'src/views/serviceClient/ServiceClientsDetailsView';
import { CreateServiceClientVehicle } from 'src/views/serviceClient/CreateServiceClientVehicle';
import { EditServiceClientVehicle } from 'src/views/serviceClient/EditServiceClientVehicle';
import { ServiceClientCreateView } from 'src/views/serviceClient/ServiceClientCreateView';
import { ServiceClientEditView } from 'src/views/serviceClient/ServiceClientEditView';

export const Routes = [
    {
        exact: true,
        path: '/create/service-client',
        guard: PermissionsGuard,
        roles: {
            permission: SERVICE_CLIENT_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: ServiceClientCreateView,
    },
    {
        exact: true,
        path: '/management/service-clients/:serviceClientId',
        guard: PermissionsGuard,
        roles: {
            permission: SERVICE_CLIENT_AUTH,
            crud: READ_PERMISSION,
        },
        component: ServiceClientsDetailsView,
    },
    {
        exact: true,
        path: '/management/service-clients/:serviceClientId/edit',
        guard: PermissionsGuard,
        roles: {
            permission: SERVICE_CLIENT_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: ServiceClientEditView,
    },
    {
        exact: true,
        path: '/management/service-clients',
        guard: PermissionsGuard,
        roles: {
            permission: SERVICE_CLIENT_AUTH,
            crud: READ_PERMISSION,
        },
        component: ServiceClientsList,
    },
    {
        exact: true,
        path: '/management/service-clients/:serviceClientId/create/vehicle',
        guard: PermissionsGuard,
        roles: {
            permission: SERVICE_CLIENT_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: CreateServiceClientVehicle,
    },
    {
        exact: true,
        path: '/management/service-clients/:serviceClientId/vehicles/:vehicleId/edit',
        guard: PermissionsGuard,
        roles: {
            permission: SERVICE_CLIENT_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: EditServiceClientVehicle,
    },
];
